import React, { useState } from 'react'
import { Avatar } from 'antd'
import moment from 'moment'
import './NotificationItem.scss'
import { sanitizeHtml } from '../../../../../utils/sanitizeHtml'

const NotificationItem = ({ item }) => {
  const [showMore, setShowMore] = useState(false)
  const maxCharacters = 50

  const handleClickShowMore = () => setShowMore(!showMore)

  /**
   * Determines the displayed activity text based on the current 'showMore' state.
   * If 'showMore' is true, the full activity text is shown.
   * If the activity text is longer than maxCharacters, it truncates the text and adds an ellipsis.
   * @returns {string} The activity text to be displayed
   */
  const displayedActivity = showMore
    ? item.activity
    : item.activity.length > maxCharacters
    ? item.activity.substring(0, maxCharacters) + '...'
    : item.activity
  return (
    <div className="itemNotificationCon" key={item?.id}>
      <div className="avatarNotification">
        <Avatar size={30} src={item?.profile_pic}>
          {item?.first_name?.charAt(0)}
        </Avatar>
      </div>
      <div>
        <div className="nameText">
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(displayedActivity),
            }}
          />
          {item.activity.length > maxCharacters && (
            <button className="showmoreless-btn" onClick={handleClickShowMore}>
              {showMore ? 'Show Less' : 'Show More'}
            </button>
          )}
        </div>
        <div className="timeAgoText">{moment(new Date(item?.timestamp)).fromNow()}</div>
      </div>
    </div>
  )
}

export default NotificationItem
